export default __webpack_public_path__ + "static/media/108-focus-betawaves.a2dfadbb.jpeg";